import React, { useState, useEffect, useCallback } from 'react'

import { Box } from 'ui/acro'

import { breakpoints } from 'ui/acro'

import Section from '../../common/components/Section/Section'
import Carousel from '../../common/components/Carousel/Carousel'
import { FadeBox, ProgramCardLarge } from '../../common/components'
import ProgramsInProgressMobile from './ProgramsInProgressMobile'
import { axios } from 'api'
import StopProgramModal from './StopProgramModal'
import { useModal_deprecated, useWindowResize } from 'hooks'
import { ProgramsHomeContext } from 'components_v2/page_context'

const ProgramsInProgress = ({
  carousalType,
  data: config,
  location = '',
  ...rest
}) => {
  const [data, setData] = useState([])
  const [total, setTotal] = useState()
  const [pageNumber, setPageNumber] = useState(1)
  const [selectedProgramSlug, setSelectedProgramSlug] = useState(null)
  const { width } = useWindowResize()
  const isMobile = width < 768
  const modal = useModal_deprecated()

  const handleStopProgramClick = (slug) => {
    setSelectedProgramSlug(slug)
    modal.open()
  }

  const fetchProgramData = useCallback(
    ({ page = null, isRemove = false, callBack = () => {} } = {}) => {
      setPageNumber((prev) => {
        const currentPage = page || (isRemove ? 1 : prev + 1)
        if (config?.fetchDataFrom) {
          axios
            .get(
              `${config.fetchDataFrom?.replace(
                '/api/v2',
                ''
              )}?page=${currentPage}&per_page=5`
            )
            .then((res) => {
              // const totalData = data.concat(isRemove)
              isRemove
                ? setData(res.data || [])
                : setData((prevData) => prevData.concat(res.data || []))
              setTotal(res.headers.total)
              setTimeout(() => callBack(), 500)
            })
            .catch((err) => console.log(err))
        } else {
          setData(config?.carousalItems)
        }
        return currentPage
      })
    },
    [config]
  )
  useEffect(() => fetchProgramData({ page: 1 }), [fetchProgramData])

  if (!data || data.length <= 0) {
    return <></>
  }
  const [slidesOffsetBefore, slidesOffsetAfter] = [0, 0]
  return (
    <ProgramsHomeContext.Provider
      value={{ fetchProgramData, handleStopProgramClick }}
    >
      {isMobile ? (
        <Section
          id={config?.id}
          title={config?.carouselTag}
          headerText={`${config?.carousalName} (${total})`}
          linkHref={config?.buttonLinkUrl}
          cta={config?.buttonLinkName}
        >
          <ProgramsInProgressMobile
            inProgressitems={data}
            selectedProgramSlug={selectedProgramSlug}
            fetchProgramData={fetchProgramData}
            setSelectedProgramSlug={setSelectedProgramSlug}
            totalInProgressitems={total}
            pageNumber={pageNumber}
            eventName={rest?.eventName}
            location={location}
          />
        </Section>
      ) : (
        <>
          <StopProgramModal
            useModal={modal}
            selectedProgramSlug={selectedProgramSlug}
            fetchProgramData={fetchProgramData}
          />
          <Box>
            <Box display='flex' gap='2em' flexDirection='column'>
              <FadeBox
                id={config?.carousalName}
                inTrigger={data && true}
                appear={true}
              >
                <Section
                  id={config?.id}
                  title={config?.carouselTag}
                  headerText={`${config?.carousalName} (${total})`}
                  linkHref={config?.buttonLinkUrl}
                  cta={config?.buttonLinkName}
                >
                  <Carousel
                    card={ProgramCardLarge}
                    eventName={rest?.eventName}
                    location={location}
                    data={data}
                    fetchNextData={fetchProgramData}
                    totalCards={total}
                    pageNumber={pageNumber}
                    mx={['16px', '16px', '16px', '0px']}
                    breakpoints={{
                      0: {
                        slidesOffsetBefore,
                        slidesOffsetAfter
                      },
                      320: {
                        slidesPerView: location === 'homepage' ? 1.5 : 1.45,
                        slidesOffsetBefore,
                        slidesOffsetAfter
                      },
                      525: {
                        slidesPerView: 2,
                        slidesOffsetBefore,
                        slidesOffsetAfter
                      },
                      [breakpoints[0]]: {
                        slidesPerView: 2.5,
                        slidesOffsetBefore,
                        slidesOffsetAfter
                      },
                      790: {
                        slidesPerView: 3,
                        slidesOffsetBefore,
                        slidesOffsetAfter
                      },
                      900: {
                        slidesPerView: 3.5,
                        slidesOffsetBefore,
                        slidesOffsetAfter
                      },
                      [breakpoints[1]]: {
                        slidesPerView: 3.5,
                        spaceBetween: 20,
                        slidesOffsetBefore,
                        slidesOffsetAfter
                      },
                      [breakpoints[2]]: {
                        slidesPerView: 3.5,
                        slidesOffsetBefore: 0,
                        spaceBetween: 20,
                        slidesOffsetAfter: 0
                      }
                    }}
                  />
                </Section>
              </FadeBox>
            </Box>
          </Box>
        </>
      )}
    </ProgramsHomeContext.Provider>
  )
}

export default ProgramsInProgress
